<template>
<section class="w1312 main-content-wrap">
  <section class="main-content clearfix">
    <notice></notice>
    <quickLike></quickLike>
    <recommend></recommend>
  </section>
</section>
</template>

<script>
import { mapState } from 'vuex'
import notice from './notice.vue'
import quickLike from './quickLike.vue'
import recommend from './recommend.vue'
export default {
  name: '',
  data () {
    return {

    }
  },
  computed: {
    ...mapState(['sessionTarget'])
  },
  methods: {
  },
  components: {
    notice,
    quickLike,
    recommend
  }
}
</script>

<style lang="scss" scoped>

.main-content {
  position: relative;
  overflow: hidden;
  .right-container {
    margin-left: 422px;
    background: #fff;
    padding-left: 30px;
    padding-right: 30px;
    min-height: 495px;
  }
}
</style>
